// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer___Dmru","emails":"CreateEditClinics_emails__2_56N","emailTagLabel":"CreateEditClinics_emailTagLabel__XhYyJ"};